import { useCallback, useRef } from "react";
import { BrowserAgent } from "@newrelic/browser-agent";
import { isDevMode } from "src/config/env";
import { ENV_NAMES, ENV_URL_PARTS } from "./newRelicErrorReport";

declare global {
  interface Window {
    newrelic?: BrowserAgent;
  }
}

export enum LogLevel {
  ERROR = "ERROR",
  TRACE = "TRACE",
  DEBUG = "DEBUG",
  INFO = "INFO",
  WARN = "WARN",
}

interface INewRelicLogReportOptions {
  level: LogLevel;
  message: string;
  file?: string;
}

export const useLogStatus = () => {
  const loggedMessagesRef = useRef<Set<string>>(new Set());
  const isDev = isDevMode();

  return useCallback(
    (options: INewRelicLogReportOptions) => {
      if (!window) {
        return;
      }

      const { level, message, file } = options;

      const logKey = `${level}:${message}:${file}`;

      if (loggedMessagesRef.current.has(logKey)) {
        return;
      }

      loggedMessagesRef.current.add(logKey);

      if (isDev) {
        console.warn(
          "%c !!!!!!!!!!!!!!!!!!!!!! NEW RELIC WARNING !!!!!!!!!!!!!!!!!!!!!!",
          message
        );
      }

      const url = window.location.origin;

      if (isDev) {
        return;
      }

      // eslint-disable-next-line no-nested-ternary
      const environment = url.includes(ENV_URL_PARTS.DEV)
        ? ENV_NAMES.DEV
        : url.includes(ENV_URL_PARTS.STAGING)
        ? ENV_NAMES.STAGING
        : ENV_NAMES.PROD;

      window.newrelic?.log(message, {
        level,
        customAttributes: { environment, file },
      });
    },
    [isDev]
  );
};
